// extracted by mini-css-extract-plugin
export default {"container":"Button_container__31fZ8","ripple":"Button_ripple__tgTKK"};